import { render } from "./Subcategory.vue?vue&type=template&id=07eb5c9c"
import script from "./Subcategory.vue?vue&type=script&lang=js"
export * from "./Subcategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__